import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var Feedback = styled.span.withConfig({
  displayName: "FeedBack__Feedback",
  componentId: "xz0pof-0"
})(["display:inline-block;font-family:", ";font-size:", ";padding:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, rem(12), rem(4), function (_ref2) {
  var theme = _ref2.theme,
      feedbackType = _ref2.feedbackType,
      skin = _ref2.skin;
  return feedbackType === 'error' && css(["background-color:", ";color:", ";"], _get(theme, "form.error." + skin + ".backgroundColor", formTheme.form.error[skin].backgroundColor), _get(theme, 'form.error.color', formTheme.form.error.color));
});
export default Feedback;